export default __webpack_public_path__ + "static/media/s_fb.53c455c1.svg";